import routerOptions0 from "/codebuild/output/src3824961668/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.15.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_es_d18f6dcb38524ba16eb9dbd9ae341849/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}